import { Fragment, Suspense } from "react";
import { ScrollView, View, YStack } from "tamagui";

import { api } from "~/utils/api";
import { useTrackOnce } from "~/hooks/use-track";
import { AppointmentCard } from "./appointment-card";
import type { PayPlan } from "./payment-plan";
import { VariantDefault } from "./variants/variant-default";
import { VariantDobrobut } from "./variants/variant-dobrobut";
import { VariantFozzy } from "./variants/variant-fozzy";

export const PaymentModal = ({ onClose }: { onClose: () => void }) => {
  useTrackOnce("Render Payment Modal");
  return (
    <View
      style={{
        position: "absolute",
        zIndex: 50,
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        backdropFilter: "blur(4px)",
        minHeight: "100vh",
        width: "100vw",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
      onPress={onClose}
    >
      <ScrollView>
        <YStack
          gap={"$2"}
          marginVertical={"$2"}
          justifyContent={"center"}
          maxWidth={"1400px"}
          $gtSm={{
            gap: 0,
            marginVertical: "$10",
            flexDirection: "row",
            alignItems: "stretch",
          }}
        >
          <Suspense>
            <PaymentCards />
            <AppointmentCard />
          </Suspense>
        </YStack>
      </ScrollView>
    </View>
  );
};

const PaymentCards = () => {
  const [{ plans }] = api.payments.getPlans.useSuspenseQuery();

  return <Fragment>{plans.map(renderPaymentCard)}</Fragment>;
};

function renderPaymentCard(plan: PayPlan) {
  switch (plan.variant) {
    case "dubrobut":
      return <VariantDobrobut key={plan.id} plan={plan} />;
    case "fozzy":
      return <VariantFozzy key={plan.id} plan={plan} />;
    default:
      return <VariantDefault key={plan.id} plan={plan} />;
  }
}
